import { twMerge } from 'tailwind-merge';

type DividerProps = {
  width?: string;
  height?: string;
  margin?: string;
  className?: string;
};

const Divider = ({ width = '100%', height = '1px', margin = '0', className }: DividerProps) => {
  return (
    <div
      className={twMerge('bg-[#DEDEF2]', className)}
      style={{ width: width, height: height, margin: margin }}
    />
  );
};

export default Divider;
